/* tslint:disable */
/* eslint-disable */
/**
 * MrbilitContent
 * Content management service for mrbilit website
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: badihi.2006@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AppDeprecationsCountGet200Response } from '../model';
// @ts-ignore
import { MusicList } from '../model';
// @ts-ignore
import { NewMusicList } from '../model';
/**
 * MusicListApiMusicListsCountGet - axios parameter creator
 * 
 * @summary 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function MusicListApiMusicListsCountGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/music-lists/count`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * MusicListApiMusicListsGet - axios parameter creator
 * 
 * @summary 
 * @param {number} [limit] Maximum number of results possible
 * @param {string} [sort] Sort according to a specific field.
 * @param {number} [start] Skip a specific number of entries (especially useful for pagination)
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function MusicListApiMusicListsGetAxiosParamCreator (limit?: number, sort?: string, start?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/music-lists`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (limit !== undefined) {
        localVarQueryParameter['_limit'] = limit;
    }

    if (sort !== undefined) {
        localVarQueryParameter['_sort'] = sort;
    }

    if (start !== undefined) {
        localVarQueryParameter['_start'] = start;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * MusicListApiMusicListsIdDelete - axios parameter creator
 * Delete a record
 * @summary 
 * @param {string} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function MusicListApiMusicListsIdDeleteAxiosParamCreator (id: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('musicListsIdDelete', 'id', id)
    const localVarPath = `/music-lists/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * MusicListApiMusicListsIdGet - axios parameter creator
 * 
 * @summary 
 * @param {string} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function MusicListApiMusicListsIdGetAxiosParamCreator (id: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('musicListsIdGet', 'id', id)
    const localVarPath = `/music-lists/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * MusicListApiMusicListsIdPut - axios parameter creator
 * Update a record
 * @summary 
 * @param {string} id 
 * @param {NewMusicList} newMusicList 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function MusicListApiMusicListsIdPutAxiosParamCreator (id: string, newMusicList: NewMusicList, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('musicListsIdPut', 'id', id)
    // verify required parameter 'newMusicList' is not null or undefined
    assertParamExists('musicListsIdPut', 'newMusicList', newMusicList)
    const localVarPath = `/music-lists/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(newMusicList, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * MusicListApiMusicListsPost - axios parameter creator
 * Create a new record
 * @summary 
 * @param {NewMusicList} newMusicList 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function MusicListApiMusicListsPostAxiosParamCreator (newMusicList: NewMusicList, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'newMusicList' is not null or undefined
    assertParamExists('musicListsPost', 'newMusicList', newMusicList)
    const localVarPath = `/music-lists`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(newMusicList, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for musicListsGet operation in MusicListApi.
 * @export
 * @interface MusicListApiMusicListsGetRequest
 */
export interface MusicListApiMusicListsGetRequest {
    /**
     * Maximum number of results possible
     * @type {number}
     * @memberof MusicListApiMusicListsGet
     */
    readonly limit?: number

    /**
     * Sort according to a specific field.
     * @type {string}
     * @memberof MusicListApiMusicListsGet
     */
    readonly sort?: string

    /**
     * Skip a specific number of entries (especially useful for pagination)
     * @type {number}
     * @memberof MusicListApiMusicListsGet
     */
    readonly start?: number
}

/**
 * Request parameters for musicListsIdDelete operation in MusicListApi.
 * @export
 * @interface MusicListApiMusicListsIdDeleteRequest
 */
export interface MusicListApiMusicListsIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof MusicListApiMusicListsIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for musicListsIdGet operation in MusicListApi.
 * @export
 * @interface MusicListApiMusicListsIdGetRequest
 */
export interface MusicListApiMusicListsIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof MusicListApiMusicListsIdGet
     */
    readonly id: string
}

/**
 * Request parameters for musicListsIdPut operation in MusicListApi.
 * @export
 * @interface MusicListApiMusicListsIdPutRequest
 */
export interface MusicListApiMusicListsIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof MusicListApiMusicListsIdPut
     */
    readonly id: string

    /**
     * 
     * @type {NewMusicList}
     * @memberof MusicListApiMusicListsIdPut
     */
    readonly newMusicList: NewMusicList
}

/**
 * Request parameters for musicListsPost operation in MusicListApi.
 * @export
 * @interface MusicListApiMusicListsPostRequest
 */
export interface MusicListApiMusicListsPostRequest {
    /**
     * 
     * @type {NewMusicList}
     * @memberof MusicListApiMusicListsPost
     */
    readonly newMusicList: NewMusicList
}

/**
* 
* @summary 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function MusicListApiMusicListsCountGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await MusicListApiMusicListsCountGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<AppDeprecationsCountGet200Response> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary 
* @param {MusicListApiMusicListsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function MusicListApiMusicListsGet(requestParameters: MusicListApiMusicListsGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await MusicListApiMusicListsGetAxiosParamCreator(requestParameters.limit, requestParameters.sort, requestParameters.start, options, configuration);
    const request: () => AxiosPromise<Array<MusicList>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Delete a record
* @summary 
* @param {MusicListApiMusicListsIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function MusicListApiMusicListsIdDelete(requestParameters: MusicListApiMusicListsIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await MusicListApiMusicListsIdDeleteAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<number> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary 
* @param {MusicListApiMusicListsIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function MusicListApiMusicListsIdGet(requestParameters: MusicListApiMusicListsIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await MusicListApiMusicListsIdGetAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<MusicList> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Update a record
* @summary 
* @param {MusicListApiMusicListsIdPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function MusicListApiMusicListsIdPut(requestParameters: MusicListApiMusicListsIdPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await MusicListApiMusicListsIdPutAxiosParamCreator(requestParameters.id, requestParameters.newMusicList, options, configuration);
    const request: () => AxiosPromise<MusicList> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Create a new record
* @summary 
* @param {MusicListApiMusicListsPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function MusicListApiMusicListsPost(requestParameters: MusicListApiMusicListsPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await MusicListApiMusicListsPostAxiosParamCreator(requestParameters.newMusicList, options, configuration);
    const request: () => AxiosPromise<MusicList> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
